export const getImgHeight = (len: number) => {
  if (len === 1) {
    return {
      height: 428,
      deskHeight: 570,
    };
  }

  return {
    height: 428,
    deskHeight: 376,
  };
};
